import React, { useEffect, useState } from 'react'
import FlexView from 'react-flexview'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import {PriceWithComma} from '../../../Core/PriceWithComma';
import './Modify.scss'
import NewButtonPopup from '../../../Core/Buttons/NewButtonPopup'
import { awaitWithLoading } from '../../../../services/utils'


import {ModificationContextStore} from '../../../../context/ModificationContext'
import { PolicyRenewalContextStore } from '../../../../context/PolicyRenewalContext'
import { CustomizeNumberOfDronesSection } from "../../../Insurance/CustomizePolicySections/CustomizeNumberOfDronesSection"
import { Grid, Radio,FormControlLabel, Checkbox, RadioGroup } from '@material-ui/core';
import { SessionService } from '../../../../services/SessionService';
import { BrowserView, MobileView } from 'react-device-detect';
import { SkywatchDialog } from '../../../PopUps/SkywatchDialog';
import { ContinueButton } from '../../../Core/Buttons/ContinueButton';


interface PolicyAdditionalInsuredSectionProps {
    insurance: ActiveInsuranceModel
}

export const CancelButton = ({onClick, children, ...props}) => <button className='midterm-cancel empty-btn ' onClick={() => onClick && onClick()} {...props}>{children}</button>
export const SubmitButton = ({onClick, children, ...props}) => <button className='midterm-submit empty-btn ' onClick={() => onClick && onClick()} {...props}>{children}</button>

export const ActionsSection = ({insurance,isOpen, closeDialog, isRenewal}: PolicyAdditionalInsuredSectionProps) => {
    const modificationContext = React.useContext(ModificationContextStore)
    const [disabled, setDisabled] = useState(false)
    const [withoutCC, setWithoutCC] = useState(false)
    const [error, setError] = useState("")
    const modificationObject = isRenewal ? modificationContext.subscription : modificationContext.insurance
    const [showPrice, setShowPrice] = useState(true)
    const [showCommercialPopup, setShowCommercialPopup] = useState(false)
    const [HaveCommercialApproved, setHaveCommercialApproved] = useState(false)
    const [signPopUp, setSignPopUp] = useState(null)


    
    useEffect(() => {
        let x= modificationContext.insurance.stripeCustomerId
        setHaveCommercialApproved(modificationContext.insurance.drones.length > 0 || modificationContext.insurance.liabilityLimit > 1000000)
        const validationList = [modificationContext.isAddionalCoverageValid, modificationContext.isHullSectionValid, modificationContext.isLiabilityValid, modificationContext.isNumberOfDronesValid]
        if(validationList.some(v => v === false )){
            setShowPrice(false)
            setDisabled(true)
            setError("Check for required fields/invalid data")
        }else{
            setShowPrice(true)
            setDisabled(false)
            setError("")
        }

    },[modificationContext.isAddionalCoverageValid, modificationContext.isHullSectionValid, modificationContext.isLiabilityValid, modificationContext.isNumberOfDronesValid])
    
    const paymentMethodChange = (event) => {
        setWithoutCC(!withoutCC)
    }

    const onContinue = async () => {
        setHaveCommercialApproved(true)
        setShowCommercialPopup(false)
    }


    useEffect(()=>{
        if (!showCommercialPopup && HaveCommercialApproved){
            submitModify()
        }
    },[showCommercialPopup])


    const submitModify = async () =>{
        const needApproval = modificationContext.insurance.drones.length > 0 || modificationContext.insurance.liabilityLimit > 1000000;
        if (!HaveCommercialApproved && needApproval){
            setShowCommercialPopup(true)
        }
        if((HaveCommercialApproved || !needApproval)){
            await awaitWithLoading(modificationContext.modify(isRenewal, withoutCC, signPopUp)); 
            closeDialog()
        }
    }

    return (     
            <Grid item xs={12} spacing={4}>
                <FlexView vAlignContent={'center'} hAlignContent='center'>
                    {!!error && <div className='text-body red'>{error}</div>}
                </FlexView>
                <Grid container direction='column' className="actions-footer">
                    <MobileView>
                        <Grid className='price-subtitle margin-bottom-6' container justifyContent='space-between' alignItems='center'>
                            <div>{isRenewal ?'Next renewal price:':'Additional charge:'}</div>
                            <PriceWithComma price={!!modificationObject && showPrice ? modificationObject.price : 0 }/>
                        </Grid>
                    </MobileView>
                    <Grid container justifyContent='space-between'>
                        <CancelButton onClick={()=>closeDialog()}>Cancel</CancelButton>
                        <div style={{display: 'flex', flexDirection: 'row'}}>
                            <BrowserView>
                                <div className='price-subtitle' style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '1rem'}}>
                                    <div className='bold'>{isRenewal ?'Next renewal price:':'Additional charge:'}</div>
                                    <PriceWithComma className='bolder' price={!!modificationObject && showPrice ? modificationObject.price : 0 }/>
                                </div>
                            </BrowserView>
                            <SubmitButton withFill={true} disabled={disabled || (!modificationObject.insuranceChanged && !isRenewal)|| (modificationContext.insurance.stripeCustomerId === undefined && !SessionService.isAdmin() && !isRenewal) || 
                                (modificationContext.insurance.stripeCustomerId === undefined && SessionService.isAdmin() && !isRenewal && !withoutCC)} onClick={async ()=>{submitModify()}}>Update Policy</SubmitButton>
                        </div>
                    </Grid>
                    <div>{(!isRenewal && SessionService.isAdmin()) &&                     
                (<FormControlLabel  control={<Checkbox
                    checked={withoutCC}
                    onChange={paymentMethodChange}
                    color="primary" />} value={withoutCC}  label={'Charge midterm without Credit Card (the user was charged manually)'} />)}
            </div>
    </Grid>
             <SkywatchDialog 
             open={showCommercialPopup} 
             maxWidth={'sm'}
             includeCancelButton={true}
             closeDialog={() => setShowCommercialPopup(false)}
         >
                 <div className="blue bold text-title textcenter margin-bottom-basic">To continue please confirm the following:</div>
                 <div className="textleft  margin-bottom-basic">Will all commercial operations be conducted by an operator who holds a Remote Pilot Airman Certificate (RPAC) or under a Certificate of Authorization or Waiver (public entities only)?</div>
                 <RadioGroup
                 className={MobileView ? "margin-top-basic" : ""}
                 name="sign_popup"
                 
                 onChange={(e) => setSignPopUp(e.target.value == "true")}
                 >
                 <Grid container style={{justifyContent: 'center'}} >
                     <FormControlLabel
                         value="false"
                         control={<Radio color="primary" />}
                         label="No"
                         labelPlacement="end"
                         style={{marginLeft: '15px'}}
                     />
                     <FormControlLabel
                         value="true"
                         control={<Radio color="primary" />}
                         label="Yes"
                         labelPlacement="end"
                         style={{marginLeft: '60px'}}
                     />
                 </Grid>
                 </RadioGroup>
 
                 <FlexView hAlignContent='center' vAlignContent='center' style={{marginBottom: '15px', marginTop: '10px'}}>
                    <ContinueButton disabled={!signPopUp} onClick={() => onContinue()} >Continue</ContinueButton>
                 </FlexView>
                     
                 {!signPopUp &&
                     <div className="red textleft margin-bottom-basic">Confirmation is required for edit, please contact support.</div>
                 }    
         </SkywatchDialog>
         </Grid>
         )
}